import {Inject, Injectable} from '@angular/core';
import {Router, UrlTree} from '@angular/router';
import {REQUESTED_URL_KEY} from '../../common/constants';
import {ROUTE_REDIRECTS_TOKEN, RouteRedirects} from '../../models/route-redirects';
import {LocalStorageService} from '../../services/local-storage.service';
import {RouteChangesService} from '../../services/route-changes.service';
import {AuthService} from './auth.service';

@Injectable()
export class AuthGuard {

    constructor(
        private authService: AuthService,
        private router: Router,
        private routeChangesService: RouteChangesService,
        private localStorageService: LocalStorageService,

        @Inject(ROUTE_REDIRECTS_TOKEN)
        private routeRedirects: RouteRedirects
    ) {}

    public canActivate(): boolean | UrlTree {
        if (this.authService.userRole) {
            return true;
        }

        const requestedUrl = this.routeChangesService.nextRoute && this.routeChangesService.nextRoute.urlAfterRedirects;

        if (requestedUrl && requestedUrl !== this.routeRedirects.LOGIN_ROUTE) {
            this.localStorageService.set(REQUESTED_URL_KEY, requestedUrl);
        }

        const url = this.routeRedirects.LOGIN_ROUTE;

        return this.router.parseUrl(url);
    }
}
